<template>
	<v-data-table
		:headers="headers"
		:items="tramitacoesEmenda"
		hide-default-footer
		:no-data-text="noDataMessage"
		single-expand
		:expanded.sync="expanded"
		item-key="id"
		sort-by="id"
		sort-desc
	>
		<!-- show-expand -->

		<!-- <template v-slot:expanded-item="{ headers, item }"> -->
			<!-- <td :colspan="headers.length"> -->
				<!-- <v-row> -->
					<!-- <v-col md="1"> <b>Data Tramitação</b> {{ item.despacho }} </v-col> -->
					<!--<v-col md="1"> <b>Ano:</b> {{ item.anoOrcamento }} </v-col>
					<v-col md="10">
						<b>Órgão:</b> {{ item.orgaoCodigo }} - {{ item.orgaoDescricao }}
					</v-col>
					<v-col md="6">
						<b>Função:</b> {{ item.funcaoCodigo }} - {{ item.funcaoDescricao }}
					</v-col>
					<v-col md="6">
						<b>Subfunção:</b> {{ item.subfuncaoCodigo }} -
						{{ item.subfuncaoDescricao }}
					</v-col>
					<v-col md="6">
						<b>Programa:</b> {{ item.programaCodigo }} -
						{{ item.programaDescricao }}
					</v-col>
					<v-col md="6">
						<b>Ação:</b> {{ item.acaoCodigo }} - {{ item.acaoDescricao }}
					</v-col>
					<v-col md="12">
						<b>Clas. Economica:</b> {{ item.economicaCodigo }} -
						{{ item.economicaDescricao }}
					</v-col>
					<v-col md="6">
						<b>Fonte:</b> {{ item.fonteCodigo }} - {{ item.fonteDescricao }}
					</v-col>
					<v-col md="6">
						<b>Cód. Aplicação:</b> {{ item.aplicacaoCodigo }} -
						{{ item.aplicacaoDescricao }}
					</v-col>
					<v-col md="3">
						<b>Valor Fixado Inicial:</b> {{ item.valorFixadoInicial$ }}
					</v-col>
					<v-col md="3">
						<b>Valor Suplementado:</b> {{ item.valorSuplementado$ }}
					</v-col>
					<v-col md="3"> <b>Valor Anulado:</b> {{ item.valorAnulado$ }} </v-col>
					<v-col md="3">
						<b>Valor Fixado Final:</b> {{ item.valorFixadoFinal$ }}
					</v-col> -->
				<!-- </v-row> -->
			<!-- </td> -->
		<!-- </template> -->
		<!-- <template v-slot:[`item.actions`]="{ item }">
			<v-btn
				color="danger"
				small
				@click="removeItem(item)"
				:disabled="readOnly"
			>
				Remover dotação
			</v-btn>
		</template> -->
	</v-data-table>
</template>

<script>
export default {
	props: ['value', 'readOnly'],
	data() {
		let tramitacoesEmenda = [...this.value];
		// dotacoes.forEach(d => {
		// 	d.valorFixadoInicial$ = this.setMascara(d.valorFixadoInicial);
		// 	d.valorSuplementado$ = this.setMascara(d.valorSuplementado);
		// 	d.valorAnulado$ = this.setMascara(d.valorAnulado);
		// 	d.valorFixadoFinal$ = this.setMascara(d.valorFixadoFinal);
		// });

		return {
			tramitacoesEmenda,
			headers: [
				// { text: 'No.', value: 'id' },
				{ text: 'Data Tramitação', value: 'dataTramitacao' },
				//{ text: 'Origem', value: 'emendaSituacaoFluxo.emendaSituacaoOrigem.descricao' },
				{ text: 'Destino', value: 'emendaSituacaoFluxo.emendaSituacaoDestino.descricao' },
				{ text: 'Despacho', value: 'despacho' },
				// { text: 'Subfunção', value: 'nomeParlamentar' },
				// { text: 'Programa', value: 'esfera' },
				//{ text: 'Ação', value: 'acaoDescricao' },
				// { text: 'Ação', value: 'acaoCodigo' },
				// { text: 'Clas. Economica', value: 'valorMascara' },
				//{ text: 'Fonte', value: 'fonteDescricao' },
				// { text: 'Fonte', value: 'fonteCodigo' },
				// { text: 'Aplicação', value: 'valorMascara' },
				// { text: 'Valor Fixado Inicial', value: 'valorFixadoInicial$' },
				// { text: 'Valor Suplementado', value: 'valorSuplementado$' },
				// { text: 'Valor Anulado', value: 'valorAnulado$' },
				// { text: 'Valor Fixado Final', value: 'valorFixadoFinal$' },
				// { text: '', value: 'data-table-expand' },
				// { text: '', value: 'actions', sortable: false }
			],
			noDataMessage: 'Não existem tramitações para esta emenda.',
			expanded: []
		};
	},
	watch: {
		value() {
			let tramitacoesEmenda = [...this.value];
			// dotacoes.forEach(d => {
			// 	d.valorFixadoInicial$ = this.setMascara(d.valorFixadoInicial);
			// 	d.valorSuplementado$ = this.setMascara(d.valorSuplementado);
			// 	d.valorAnulado$ = this.setMascara(d.valorAnulado);
			// 	d.valorFixadoFinal$ = this.setMascara(d.valorFixadoFinal);
			// });
			this.tramitacoesEmenda = tramitacoesEmenda;
		}
	},
	// methods: {
	// 	setMascara(v) {
	// 		return v.toLocaleString('pt-BR', {
	// 			minimumFractionDigits: 2,
	// 			maximumFractionDigits: 2,
	// 			style: 'currency',
	// 			currency: 'BRL'
	// 		});
	// 	},
	// 	removeItem(item) {
	// 		this.dotacoes = this.dotacoes.filter(d => d !== item);
	// 		this.$emit('input', this.dotacoes);
	// 	}
	// }
};
</script>
